// extracted by mini-css-extract-plugin
export var BlogCard = "BlogCard-module--BlogCard--2XrgY";
export var Card = "BlogCard-module--Card--1nib6";
export var Image = "BlogCard-module--Image--2J8-E";
export var BlogInfo = "BlogCard-module--BlogInfo--1Ljjh";
export var TeamCard = "BlogCard-module--TeamCard--2zNDu";
export var Title = "BlogCard-module--Title--221CE";
export var Date = "BlogCard-module--Date--3sX-U";
export var Tags = "BlogCard-module--Tags--23GRt";
export var Name = "BlogCard-module--Name--2fARx";